import { useMutation } from '@tanstack/react-query';

import { postMyPosPayment } from '../api/payment.api';

interface PostMyPosPaymentParams {
    orderId: string | undefined;
    loyaltyId: number;
}

export const usePostMyPosPayment = () => {
    return useMutation({
        mutationFn: ({ orderId, loyaltyId }: PostMyPosPaymentParams) =>
            postMyPosPayment(orderId, loyaltyId),
    });
};
